module.exports = __webpack_public_path__ + "img/subAra10.23722a93.jpg";